import { Component, OnInit } from '@angular/core';
import { PagesService } from '../../services/pages.service';

@Component({
	selector: 'app-company',
	templateUrl: './company.page.html',
	styleUrls: ['./company.page.scss'],
})
export class CompanyPage implements OnInit {
	currentPagePermission = 'company';

	constructor(public pagesService: PagesService) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app',
		);

		//
	}

	ngOnInit() {
		//
	}
}
